import axios, { AxiosRequestConfig } from 'axios'

const apiClient = axios.create({
    baseURL: 'handlers/appbuilder.ashx',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export default {
    getApplicationCategories() {
        const data = new FormData();
        data.append('type', 'getAllAppCategory');

        const config: AxiosRequestConfig = {
            method: 'post',
            data: data
        };

        return apiClient(config);
    },
}
